import { Paper, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import React from 'react';

export interface RiskToggleBarProps {
  riskLevels: string[];
  effectiveRiskLevel: string | null;
  onSelect: (val: string) => void;
}

export const RiskToggleBar: React.FC<RiskToggleBarProps> = ({
  riskLevels,
  effectiveRiskLevel,
  onSelect,
}) => {
  const hasRiskII = riskLevels.length > 1;
  return (
    <Paper
      variant="outlined"
      sx={{ px: 2, py: 1.5, mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}
    >
      <Typography variant="body2" fontWeight={600}>
        Risk Level:
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={effectiveRiskLevel ?? riskLevels[0] ?? 'I'}
        onChange={(_, val: string | null) => {
          if (val) onSelect(val);
        }}
      >
        <ToggleButton
          value={riskLevels[0] ?? 'I'}
          sx={{ px: 2.5, textTransform: 'none', fontWeight: 500 }}
        >
          Risk I
        </ToggleButton>
        <Tooltip
          title={!hasRiskII ? 'No Risk II data available for this manufacturer' : ''}
          disableHoverListener={hasRiskII}
        >
          <span>
            <ToggleButton
              value={riskLevels[1] ?? 'II'}
              disabled={!hasRiskII}
              sx={{ px: 2.5, textTransform: 'none', fontWeight: 500 }}
            >
              Risk II
            </ToggleButton>
          </span>
        </Tooltip>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
        <strong>Risk I:</strong> Default for all orders &nbsp;|&nbsp;
        <strong>Risk II:</strong> Permanent Dwelling only
      </Typography>
    </Paper>
  );
};
